import axios from 'axios';
import Cookies from 'js-cookie';

const ApiUrl = "https://admin.ellydecor.in/api/v2";

const api = axios.create({
  baseURL: ApiUrl,
  headers: {
    'Content-Type': 'application/json',
    'System-Key': 'kjshdf7678',
    'X-Requested-With' : 'XMLHttpRequest'
  },
});

// api.interceptors.request.use(config => {
//   const csrfToken = Cookies.get('X-CSRF-TOKEN');
//   if (csrfToken) {
//     config.headers['X-CSRF-TOKEN'] = csrfToken;
//   }
//   return config;
// }, error => {
//   return Promise.reject(error);
// });

export default api;
